import React from 'react';
import styles from './Icons.module.scss';

type ZoomOutButtonProps = {
  onClick: () => void;
}

const ZoomOutButton: React.FC<ZoomOutButtonProps> = ({onClick}) => {
  return(
    <div onClick={onClick} className={styles.ZoomOutButton}>
      <div className={styles.ZoomOutIcon} />
    </div>
  )
}

export default ZoomOutButton;




